import React from 'react';

const EditIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path 
                d="M10.8507 
                4.85699L13.2077 
                2.49997L17.3325
                6.62476L14.9755
                8.98178M10.8507
                4.85699L2.89402
                12.8137C2.70648
                13.0012
                2.60113
                13.2556
                2.60113
                13.5208L2.60113
                17.2314L6.3117
                17.2314C6.57692
                17.2314
                6.83127
                17.126
                7.01881
                16.9385L14.9755
                8.98178M10.8507
                4.85699L14.9755 
                8.98178" 
                stroke="#595959" 
                strokeLinecap="round" 
                strokeLinejoin="round" />
        </svg>
    );
};

export default EditIcon;
